export default "__VITE_ASSET__CQHjzXCj__"